// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"dd07be62","453":"b4a1899f"}[chunkId] + ".chunk.js";
};